<template>
  <div class="questionList">
    <bread-crumb></bread-crumb>
    <man-form-list
      :select="select"
      :selectList="selectList"
      @getChangeValue="getData"
      :isBtn="1"
      @empty="empty"
      @disease_remoteMethod="getDiseases"
      @doctor_remoteMethod="getDoctor"
      :isShowFilter="isShowFilter"
      @searchFilter="searchFilter"
      @checkBoxedChange="checkBoxedChange"
      @clickSingleBoxed="clickSingleBoxed"
      @popHide="popHide"
      :searchFilterList="searchFilterList"
      :checkList="checkList"
    ></man-form-list>
    <div class="tbl">
      <el-row class="import-btn" type="flex" justify="end">
        <el-dropdown @command="importChangeFn" style="margin-right: 15px">
          <el-button type="primary">
            导入功能<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :command="item.value"
              v-for="item in importList"
              :key="item.value"
              >{{ item.label }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown @command="exportChangeFn">
          <el-button type="primary">
            导出功能<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :command="itm.value"
              v-for="itm in exportList"
              :key="itm.label"
              :disabled="itm.disabled"
              >{{ itm.label }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown
          @command="batchesOfflineFn"
          style="margin-left: 15px"
          v-if="userInfo.tenantManager"
        >
          <el-button type="primary">
            批量下线<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :command="itm.value"
              v-for="itm in batchesOfflineList"
              :key="itm.label"
              :disabled="itm.disabled"
              >{{ itm.label }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 导出商品Export -->
        <!-- <el-button
          type="text"
          @click="dialogOutContentSkusVisibleSku = true"
        >批量导出商品
        </el-button>
        <el-button class="redTag"
          type="text"
          v-if="isSaleExportErrorShow"
          @click="downloadDiles(8)"
        >导出商品失败
        </el-button> -->
        <!-- 导入商品Import -->
        <!-- <div class="importBtn">
          <el-button
            type="primary"
            @click="dialogInContentSkusVisible = true"
          >批量导入商品
          </el-button>
        </div>
        <div class="importBtn">
          <el-button
            type="danger"
            v-if="isSaleImportErrorShow"
            @click="downloadDiles(7)"
          >导入商品失败
          </el-button>
        </div> -->

        <!-- 导出类目Export -->
        <!-- <el-button
          type="text"
          @click="dialogOutCategoryVisible = true"
        >批量导出类目
        </el-button>
        <el-button class="redTag"
          type="text"
          v-if="isExportErrorShow"
          @click="downloadDiles(5)"
        >导出类目失败
        </el-button> -->
        <!-- 导入类目Import -->

        <!-- <div class="importBtn">
          <el-button
            type="primary"
            @click="dialogInCategoryVisible = true"
          >批量导入类目
          </el-button>
        </div>

        <div class="importBtn">
          <el-button
            type="danger"
            v-if="isImportErrorShow"
            @click="downloadDiles(4)"
          >导入类目失败
          </el-button>
        </div> -->
        <!-- 导入问答 -->
        <!-- <div class="importBtn">
          <el-button
            type="primary"
            @click="dialogTableVisible = true"
          >批量导入问答
          </el-button>
        </div>

        <div class="importBtn">
          <el-button
            type="danger"
            v-if="isDownShow"
            @click="downloadDiles(2)"
          >下载失败数据
          </el-button>
        </div> -->
      </el-row>

      <el-tabs v-model="tabActiveName" @tab-click="tabHandleClick">
        <el-tab-pane
          :label="item.name"
          :name="item.name"
          v-for="item in questionTabList"
          :key="item.name"
        >
          <span slot="label" class="slot-item">
            <span>{{ item.name }}</span
            ><span>{{ item.count }}</span>
          </span>
          <div class="base-table">
            <div class="base-table-table">
              <el-table :data="tblData" style="width: 100%">
                <el-table-column
                  prop="contentId"
                  label="问题ID"
                ></el-table-column>
                <el-table-column
                  prop="contentName"
                  label="问题"
                ></el-table-column>
                <el-table-column label="提问人">
                  <template slot-scope="scope">
                    <span>{{ scope.row.createUser }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="提问时间">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.submitTime || scope.row.createTime | time
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="审核时间">
                  <template slot-scope="scope">
                    <span>{{ scope.row.auditInfo.auditTime | time }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="审核人">
                  <template slot-scope="scope">
                    <span>{{ scope.row.auditInfo.auditUser }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="问答来源">
                  <template slot-scope="scope">
                    <div v-for="item in questionFrom">
                      <span v-if="scope.row.sourceType === item.value">{{
                        item.label
                      }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="审核状态">
                  <template slot-scope="scope">
                    <span
                      v-if="[2, 3].includes(scope.row.auditInfo.auditStatus)"
                      :class="
                        scope.row.auditInfo.auditStatus == 3
                          ? 'adopt-color'
                          : 'reviewed-color'
                      "
                    ></span>
                    <el-tooltip
                      effect="dark"
                      :content="scope.row.auditInfo.remark"
                      placement="top"
                      style="display: inline-block"
                      v-if="scope.row.auditInfo.auditStatus == 4"
                    >
                      <div
                        :class="
                          scope.row.auditInfo.auditStatus == 4 ? 'rejected' : ''
                        "
                      >
                        {{ scope.row.auditInfo.auditStatus | auditStatus }}
                        <i class="el-icon-warning-outline"></i>
                      </div>
                    </el-tooltip>
                    <div v-else style="display: inline-block">
                      {{ scope.row.auditInfo.auditStatus | auditStatus }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="问答状态">
                  <template slot-scope="scope">
                    <el-tooltip
                      effect="dark"
                      :content="scope.row.statusInfo.remark"
                      placement="top"
                      style="display: inline-block"
                      v-if="scope.row.contentStatus == 2"
                    >
                      <div
                        :class="scope.row.contentStatus == 2 ? 'rejected' : ''"
                      >
                        {{ scope.row.contentStatus == 1 ? "已上线" : "已下线" }}
                        <i
                          class="el-icon-warning-outline"
                          v-if="scope.row.contentStatus == 2"
                        ></i>
                      </div>
                    </el-tooltip>
                    <div v-else-if="scope.row.contentStatus">
                      {{ scope.row.contentStatus == 1 ? "已上线" : "已下线" }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <div>
                      <el-button
                        class="operateBtn"
                        type="text"
                        size="small"
                        v-if="scope.row.auditInfo.auditStatus == 2"
                        @click="operate(scope.row)"
                        >审核</el-button
                      >
                      <el-button
                        class="operateBtn"
                        type="text"
                        size="small"
                        v-else-if="
                          scope.row.auditInfo.auditStatus == 4 ||
                          [1, 2].indexOf(scope.row.contentStatus) > -1 ||
                          scope.row.auditInfo.auditStatus == 1
                        "
                        @click="operate(scope.row)"
                        >编辑</el-button
                      >
                      <!-- 查看线上目前没地址 所以暂时点击无反应 -->
                      <el-button
                        class="operateBtn"
                        type="text"
                        size="small"
                        v-if="scope.row.contentStatus == 1"
                        @click="redirectTo(scope.row)"
                        >查看线上</el-button
                      >
                      <el-button
                        class="operateBtn"
                        type="text"
                        size="small"
                        @click="
                          dialogOfflineVisible = true;
                          operatingRow = scope.row;
                        "
                        v-if="scope.row.contentStatus == 1"
                        >下线</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <pagination
        @sizePageChange="
          (val) => {
            pagination = val;
            getPageData();
          }
        "
        :paginationDatas="pagination"
      />
    </div>
    <!--上传问答-->
    <el-dialog
      title="批量上传问答"
      :visible.sync="dialogTableVisible"
      width="30%"
      @close="closeDialog"
    >
      <el-button
        :disabled="isButton"
        type="primary"
        plain
        style="display: block; margin: auto"
        @click="downloadDiles(1)"
        >下载Excel模板
      </el-button>
      <div
        style="
          margin-top: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <input type="file" @change="fileChange" ref="file" />
        <el-button
          type="primary"
          size="medium"
          :loading="uploadShow"
          @click="uploadExl"
          style="width: 93px"
        >
          {{ uploadShow ? "上传中" : "上传" }}
        </el-button>
      </div>
      <div style="margin-top: 10px; text-align: center">
        <p>注： 1、请上传Excel文件，列表不超过1000行</p>
        <p>2、上传过程中请勿刷新</p>
      </div>
    </el-dialog>
    <!--上传问题-->
    <el-dialog
      title="批量上传问题"
      :visible.sync="dialogInQuestionVisible"
      width="30%"
      @close="closeDialog"
    >
      <el-button
        :disabled="isButton"
        type="primary"
        plain
        style="display: block; margin: auto"
        @click="downloadDiles(13)"
        >下载Excel模板
      </el-button>
      <div
        style="
          margin-top: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <input type="file" @change="fileChange" ref="file" />
        <el-button
          type="primary"
          size="medium"
          :loading="uploadShow"
          @click="uploadQuestionExl"
          style="width: 93px"
        >
          {{ uploadShow ? "上传中" : "上传" }}
        </el-button>
      </div>
      <div style="margin-top: 10px; text-align: center">
        <p>注： 1、请上传Excel文件，列表不超过1000行</p>
        <p>2、上传过程中请勿刷新</p>
      </div>
    </el-dialog>
    <!--上传类目-->
    <el-dialog
      title="批量导入类目"
      :visible.sync="dialogInCategoryVisible"
      width="30%"
      @close="closeDialog"
    >
      <el-button
        :disabled="isButton"
        type="primary"
        plain
        style="display: block; margin: auto"
        @click="downloadDiles(3)"
        >下载类目Excel模板
      </el-button>
      <div
        style="
          margin-top: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <input type="file" @change="fileChange" ref="file" />
        <el-button
          type="primary"
          size="medium"
          :loading="uploadShow"
          @click="uploadCategoryExl"
          style="width: 93px"
        >
          {{ uploadShow ? "上传中" : "上传" }}
        </el-button>
      </div>
      <div style="margin-top: 10px; text-align: center">
        <p>注： 1、请上传Excel文件，列表不超过1000行</p>
        <p>2、上传过程中请勿刷新</p>
      </div>
    </el-dialog>
    <!--导出类目-->
    <el-dialog
      title="批量导出类目"
      :visible.sync="dialogOutCategoryVisible"
      width="30%"
      @close="closeOutDialog"
    >
      <div
        style="
          margin-top: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <el-button
          type="primary"
          size="medium"
          :loading="uploadShow"
          @click="getOutContentCategory()"
          style="width: 93px"
        >
          {{ uploadShow ? "导出中" : "导出" }}
        </el-button>
      </div>
    </el-dialog>
    <!--上传商品-->
    <el-dialog
      title="批量导入商品"
      :visible.sync="dialogInContentSkusVisible"
      width="30%"
      @close="closeDialog"
    >
      <el-button
        :disabled="isButton"
        type="primary"
        plain
        style="display: block; margin: auto"
        @click="downloadDiles(9)"
        >下载商品Excel模板
      </el-button>
      <div
        style="
          margin-top: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <input type="file" @change="fileChange" ref="file" />
        <el-button
          type="primary"
          size="medium"
          :loading="uploadShow"
          @click="uploadContentSkusExl"
          style="width: 93px"
        >
          {{ uploadShow ? "上传中" : "上传" }}
        </el-button>
      </div>
      <div style="margin-top: 10px; text-align: center">
        <p>注： 1、请上传Excel文件，列表不超过1000行</p>
        <p>2、上传过程中请勿刷新</p>
      </div>
    </el-dialog>
    <!--导出商品-->
    <el-dialog
      title="批量导出商品"
      :visible.sync="dialogOutContentSkusVisibleSku"
      width="30%"
      @close="closeOutDialog"
    >
      <div
        style="
          margin-top: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <el-button
          type="primary"
          size="medium"
          :loading="uploadShow"
          @click="getOutContentContentSkus()"
          style="width: 93px"
        >
          {{ uploadShow ? "导出中" : "导出" }}
        </el-button>
      </div>
    </el-dialog>
    <!--上传问题-->
    <el-dialog
      title="批量下线内容"
      :visible.sync="dialogOutBatchesOfflineVisible"
      width="30%"
      @close="closeDialog"
    >
      <el-button
        :disabled="isButton"
        type="primary"
        plain
        style="display: block; margin: auto"
        @click="downloadDiles(bOImportExportCode)"
        >下载Excel模板
      </el-button>
      <div
        style="
          margin-top: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <input type="file" @change="fileChange" ref="file" />
        <el-button
          type="primary"
          size="medium"
          :loading="uploadShow"
          @click="uploadBatchesOfflineExl"
          style="width: 93px"
        >
          {{ uploadShow ? "上传中" : "上传" }}
        </el-button>
      </div>
      <div style="margin-top: 10px; text-align: center">
        <p>注： 1、请上传Excel文件，列表不超过1000行</p>
        <p>2、上传过程中请勿刷新</p>
      </div>
    </el-dialog>
    <!--下线-->
    <modal
      :isShow.sync="dialogOfflineVisible"
      title="下线"
      width="800px"
      :isShowBtn="[true, true]"
      :btnText="['取消', '确认']"
      @clickHandler="offlineClickHandler"
    >
      <el-form :model="rejectForm" label-width="100px" class="offlineForm">
        <span class="red">*</span>
        <el-form-item label="下线理由">
          <el-input
            size="small"
            type="textarea"
            placeholder="请输入下线理由，不超过200字"
            v-model="offLineReasons"
            :autosize="{ minRows: 4, maxRows: 6 }"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
    </modal>
  </div>
</template>
<script>
// 组件
import breadCrumb from "@/components/breadCrumb";
import pagination from "@/components/pagination";
import modal from "@/components/modal";
import ManFormList from "@/entrys/man/components/manFormList";
// api
import {
  queryDiseaseLibraryName,
  queryDoctorName,
  querySource,
  getContentStatus,
  queryBusiness,
  // TODO替换成新的问题列表接口
  queryQuestionList,
  queryQuestionStateNum,
  offlineApplication,
  importQuestionAnswer,
  importInContentCategory,
  importOutContentCategory,
  importExportLog,
} from "@/api/questionsLibrary";
import {
  manSaveUserConfig,
  manListUserConfig,
  listContentBusinessForUserMan,
  getImportTemplate,
} from "@/api/man";
import {
  getContentQuailty,
  getDistributionScope,
  searchDataProcessing,
  getGeneralLabel,
} from "../contentManage/distribution";
import { request } from "@/utils/axios";
import { manListContentIndexTree } from "@/api/indexs";
import {
  getOutArticleCategory,
  uploadCategoryExl,
  fileChange,
} from "../../components/importExportCommon";
import { mapState } from "vuex";
// 工具类
import utils from "@/utils";
const baseUrl = process.env.VUE_APP_BASEURL;

export default {
  name: "questionList",
  components: {
    ManFormList,
    breadCrumb,
    pagination,
    modal,
  },
  data() {
    return {
      isButton: false,
      uploadShow: false,
      isDownShow: false, // 下载导入失败的判断变量
      // 问题的内容类型，公共参数，下面所有用到的接口统一使用该变量
      contentType: 14, // 14-问题
      baseUrl,
      timer: null,
      //类目导入失败
      isImportErrorShow: false,
      failImportUrl: "",
      // 商品倒入失败
      isSaleImportErrorShow: false,
      failImportSaleUrl: "",
      //类目导出失败
      isExportErrorShow: false,
      failExportUrl: "",
      //商品导出失败
      isSaleExportErrorShow: false,
      failExportSaleUrl: "",
      configId: null,
      checkList: [1000],
      allSearchList: [],
      serverList: [],
      qualityList: [], // 内容质量
      businessList: [],
      articleLabels: [], // 内容标签
      indexTreeList: [],
      businessChannelArr: [],
      isShowFilter: 1,
      rangeList: [], // 分发范围
      contentAttributes: [],
      questionStatusList: [],
      // 搜索FORM字段，传给FORM组件初始化字段使用
      select: [
        {
          prop: "questionId",
          type: "input2",
          placeholder: "请输入问题ID",
          maxLenth: 18,
        },
      ],
      // 搜索FORM初始值
      selectList: {
        questionId: "", // 问题ID
        contentName: "", // 标题
        searchKeyword: "", // 全文
        symptomsDisease: null, // 疾病症状
        questionTime: [], // 提问时间
        questionSource: null, // 问题来源
        questionStatus: "", // 问题状态
        business: "", // 所属业务
        categoryId: "", // 所属栏目
        channelId: "", // 所属频道
        categoryRelationId: "", // 类目
        auditTime: [], //
        writerPin: "",
        nickname: "",
        range: "",
        hospital: "",
        quality: "",
        answerer: "", // 回答人
        contentIndexIds: [], // 索引
        contentDiseasesNotNull: "",
        isDoctor: "",
      },

      // ------------------- 批量导入 start ---------------------
      // 导入问答弹出是否显示标识
      dialogTableVisible: false,
      // 导入类目弹出是否显示标识
      dialogInCategoryVisible: false,
      // 导出类目弹出是否显示标识
      dialogOutCategoryVisible: false,
      // 导入商品弹出是否显示标识
      dialogInContentSkusVisible: false,
      // 导出商品弹出是否显示标识
      dialogOutContentSkusVisibleSku: false,
      // 批量导入问题是否显示标识
      dialogInQuestionVisible: false,
      // 问答批量上线是否显示标识
      dialogOutBatchesOfflineVisible: false,
      // 批量上传
      fileList: [],
      // ------------------- 批量导入 end ---------------------
      // ------------------- 下线弹层 start ---------------------
      // 下线弹窗填写下线理由
      dialogOfflineVisible: false,
      // 下线理由文本
      offLineReasons: "",
      // ------------------- 下线弹层 end ---------------------
      // tab页
      // 当前激活tab
      tabActiveName: "全部",
      // tab列表数据
      questionTabList: [
        {
          name: "全部",
          count: 0,
          val: [1, 2, 3, 4],
        },
        {
          name: "待审核",
          count: 0,
          val: [2],
        },
        {
          name: "已通过",
          count: 0,
          val: [3],
        },
        {
          name: "已驳回",
          count: 0,
          val: [4],
        },
      ],
      // 当前操作行的数据
      operatingRow: null,
      // 表格
      tblData: [],
      // 分页
      pagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      questionFrom: [], // 记录内容来源
      tabChange: 0, // tab切换的变量  用来区分是否需要更新tab后面的数量
      importList: [
        {
          value: "1",
          label: "批量导入商品",
        },
        {
          value: "2",
          label: "批量导入类目",
        },
        {
          value: "3",
          label: "批量导入问答",
        },
        {
          value: "4",
          label: "批量导入问题",
        },
      ], // 导入列表
      importType: "", // 选中的导入选项
      exportList: [
        {
          value: "1",
          label: "批量导出商品",
        },
        {
          value: "2",
          label: "批量导出类目",
        },
        // {
        //   value: '3',
        //   disabled: !this.isSaleExportErrorShow,
        //   label: '导出商品失败'
        // },
        // {
        //   value: '4',
        //   disabled: !this.isSaleImportErrorShow,
        //   label: '导入商品失败'
        // },
        // {
        //   value: '5',
        //   disabled: !this.isExportErrorShow,
        //   label: '导出类目失败'
        // },
        // {
        //   value: '6',
        //   disabled: !this.isImportErrorShow,
        //   label: '导入类目失败'
        // },
        // {
        //   value: '7',
        //   disabled: !this.isDownShow,
        //   label: '下载失败数据'
        // },
      ], // 导出列表
      exportType: "", // 选中的导出选项
      batchesOfflineList: [
        {
          value: "1",
          label: "批量下线内容",
        },
      ],
      bOImportExportCode: 15,
    };
  },
  async created() {
    // 查询用户保存配置
    await this.queryUserConfig();
    //  获取天空之城数据
    await this.queryFloorList();
    this.getDistributionScope(); // 获取分发范围
    // 获取内容质量
    this.getContentQuailty();
    this.listContentBusinessForUserMan();
    // 获取标签
    this.getGeneralLabel();
    this.getIndexTreeList();
    // 获取tab页的每种类型的数量
    this.getTabNum();
    // ------------------------------ 初始化下拉数据 start -----------------------------------
    // 问答来源查询
    querySource({
      tenantId: this.$commonJs.getTenantId(),
      contentType: this.contentType,
    })
      .then((res) => {
        this.questionFrom = res.map((item) => ({
          value: item.code,
          label: item.desc,
        }));
        res &&
          this.select.map((item) => {
            if (item.prop == "questionSource") {
              item.List = this.questionFrom;
              // this.selectList[item.prop] = ['全部', ...res.map(subItem => subItem.code)];
            }
          });
      })
      .catch((err) => {
        console.log("获取问答来源出错");
        console.log(err);
      });
    // 获取文章状态
    getContentStatus({
      tenantId: this.$commonJs.getTenantId(),
      contentType: this.contentType,
    })
      .then((res) => {
        let itemList = res.map((item) => ({
          value: item.code,
          label: item.desc,
        }));
        // itemList.unshift({value: null, label:"全部" })
        this.questionStatusList = itemList;
        res &&
          this.select.map((item) => {
            if (item.prop == "questionStatus") {
              let itemList = res.map((item) => ({
                value: item.code,
                label: item.desc,
              }));
              // itemList.unshift({value: null, label:"全部" })
              console.log(
                this.questionStatusList,
                "thisquestionStatusList=====getContentStatus"
              );
              item.List = itemList;
            }
          });
      })
      .catch((err) => {
        console.log("获取文章状态出错");
        console.log(err);
      });
    // 查询所属业务
    queryBusiness({ tenantId: this.$commonJs.getTenantId() })
      .then((res) => {
        res &&
          this.select.map((item) => {
            if (item.prop == "business") {
              item.List = res.map((item) => ({
                value: item.id,
                label: item.name,
              }));
            }
          });
      })
      .catch((err) => {
        console.log("获取所属业务出错");
        console.log(err);
      });
    // ------------------------------ 初始化下拉数据 end -----------------------------------
    // 获取表格数据
    this.getPageData();
  },
  filters: {
    auditStatus(data) {
      switch (data) {
        case 1:
          return "草稿";
        case 2:
          return "待审核";
        case 3:
          return "审核通过";
        case 4:
          return "已驳回";
      }
    },
    time(data) {
      if (data) {
        return utils.timetamp(data);
      }
    },
  },
  methods: {
    recursionObj(node, callback, judge) {
      if (judge(node)) {
        node = callback(node);
      }
      if (!node.contentIndexes || node.contentIndexes.length === 0) {
        return;
      }
      for (let i = 0; i < node.contentIndexes.length; i++) {
        if (judge(node)) {
          this.recursionObj(node.contentIndexes[i], callback, () => true);
        } else {
          this.recursionObj(node.contentIndexes[i], callback, judge);
        }
      }
      return;
    },
    // 获取索引下拉数据
    getIndexTreeList() {
      manListContentIndexTree().then((res) => {
        // 处理树的叶子结点
        for (let i = 0; i < res.length; i++) {
          this.recursionObj(
            res[i],
            (curNode) => {
              curNode.contentIndexes = undefined;
              return curNode;
            },
            (node) => node.contentIndexes.length === 0
          );
        }
        this.indexTreeList = res;
        this.select.map((subItem) => {
          if (subItem.prop == "contentIndexIds") {
            subItem.List = res;
          }
        });
        console.log(
          "======1=23=3030383282894u8438u239409====",
          this.indexTreeList
        );
        // const index = this.select.findIndex((item) => item.type === 'selectIndex');
        // this.select[index].List = res;
      });
    },
    // 过滤
    searchFilter() {},
    // 配置项勾选
    checkBoxedChange(value) {},
    // 点击
    clickSingleBoxed(checked, item) {
      console.log("clickSingleBoxed======>", checked, item);
      if (checked) {
        // 添加
        if (item.cfgID == 4000) {
          this.businessChannelArr.map((busItem) => {
            this.configSubItem(busItem);
            this.select.push(busItem);
          });
          this.checkList.push(item.cfgID);
        } else {
          this.checkList.push(item.cfgID);
          this.configSubItem(item);
          this.select.push(item);
        }
      } else {
        // 删除
        this.checkList = this.checkList.filter((value) => {
          if (value == item.cfgID) return false;
          return true;
        });
        if (item.cfgID == 4000) {
          this.businessChannelArr.map((busItem) => {
            busItem.List = [];
            this.selectList[busItem.prop] = "";
          });
        } else {
          this.selectList[item.prop] = "";
        }
        this.select = this.select.filter((value) => {
          if (value.cfgID == item.cfgID) return false;
          return true;
        });
      }
      let selecrData = JSON.stringify(this.select);
      sessionStorage.setItem("disBuSelectData", selecrData); // 存入筛选选择数据
    },
    configSubItem(subItem) {
      if (subItem.cfgID == 3004) {
        let arr = this.qualityList.map((item) => {
          return { value: item.id, label: item.desc };
        });
        subItem.List = arr;
      }
      if (subItem.cfgID == 3003) {
        let arr = this.rangeList.map((item) => {
          return { value: item.id, label: item.desc };
        });
        subItem.List = arr;
      }
      //
      if (subItem.cfgID == 3005) {
        subItem.List = this.questionStatusList;
      }
      if (subItem.cfgID == 4000 && subItem.prop == "business") {
        subItem.List = this.businessList;
      }
      if (subItem.cfgID == 4001) {
        subItem.List = this.articleLabels;
      }
      if (subItem.cfgID == 4002) {
        subItem.List = this.indexTreeList;
      }
      if (subItem.cfgID == 5004) {
        subItem.List = this.questionFrom;
        // this.selectList[subItem.prop] = ['全部', ...this.questionFrom.map(subItem => subItem.value)];
      }
      // if ([3000,3001,3002,3003,3004,5002,5003].includes(subItem.cfgID)){
      //     this.selectList[subItem.prop] = "全部";
      // }
    },
    // 配置项隐藏
    popHide(value) {
      console.log(value, "contentAudit--popHide");
      this.saveUserConfig({
        configId: this.configId,
        tenantId: this.$commonJs.getTenantId(),
        configCode: "1",
        sceneCode: "4",
        value: value.toString(),
      });
    },
    // 获取天空之城数据 生成页面数据
    async queryFloorList() {
      // console.log('queryFloorList=======>', 33333);
      await request("jdh_laputa_queryFloorList", {
        functionId: "reviewOnlineOffline",
        appId: "21557c5d3d0a4ec1b0184719022bb4b5",
        osName: "jdhwiki",
        venderId: null,
        inquiryTenancyId: null,
        version: 3,
      })
        .then(async (res) => {
          // this.floorTransferDTOS = res?.cf?.floorTransferDTOS;
          // console.log(res?.cf?.floorTransferDTOS[0], 'contentAudit<----来了哥----->');
          //  处理天空之城数据
          const cfgArray = res?.cf?.floorTransferDTOS[0].cfgList.filter(
            (item) => {
              if (item?.name == "manuDataCfg") {
                return true;
              }
              return false;
            }
          );
          // 整体配置数据
          let valueArray = JSON.parse(cfgArray[0].value).map((item) => {
            return JSON.parse(item?.value);
          });
          // console.log(valueArray, 'contentAudit<----来了哥----->valueArray');
          let fileterArray = [];
          let allShowSearchArr = [];
          // console.log( '=====>|||||========>',valueArray);
          // 所有配置的数据 包括 ids
          valueArray.map((item) => {
            let filerItem = this.$commonJs.deepClone(item);
            if (!Array.isArray(filerItem?.selectedIDs)) {
              // 获取搜索筛选总的展示
              filerItem.selectItems = filerItem?.selectItems.filter(
                (subItem) => {
                  return subItem.isShow;
                }
              );
              fileterArray.push(filerItem);

              item.selectItems = item?.selectItems.map((subItem) => {
                if (subItem.cfgID == 4000) {
                  this.businessChannelArr.push(subItem);
                }
                return subItem;
              });
              allShowSearchArr.push(item);
            } else {
              if (this.serverList?.length == 0) {
                // console.log('==============ppppppppp');
                this.checkList = item?.selectedIDs;
              }
            }
          });
          this.allSearchList = allShowSearchArr;
          // 搜索筛选弹框展示的数据
          this.searchFilterList = fileterArray;
          // console.log(fileterArray, '拿到我配置的数据');

          // 页面上展示搜索
          let tempSelectList = [];
          this.checkList.map((cItem) => {
            allShowSearchArr.map((item) => {
              item?.selectItems?.map((subItem) => {
                if (cItem == subItem.cfgID) {
                  tempSelectList.push(subItem);
                }
              });
            });
          });
          // 显示的搜索弹框
          this.select = tempSelectList;
          // console.log(this.select, 'queryFloorList=====>|||||======');
        })
        .catch((err) => {
          this.$message.error(err.msg || "查询失败");
        });
      // console.log('queryFloorList=======>', 44444);
    },
    // 查询用户配置
    async queryUserConfig() {
      // console.log('queryUserConfig=======>', 11111);
      await manListUserConfig({
        tenantId: this.$commonJs.getTenantId(),
        configCode: "1",
        sceneCode: "4",
      }).then((res) => {
        if (res && res?.length > 0) {
          // console.log(res, '===============>配置');
          const userConfigBizDTO = res[0];
          this.configId = userConfigBizDTO?.configId;
          // console.log(this.configId,userConfigBizDTO, 'configId=====>',userConfigBizDTO?.value.split(','));
          this.checkList = userConfigBizDTO?.value
            .split(",")
            .map((item) => parseInt(item));
          this.serverList = userConfigBizDTO?.value
            .split(",")
            .map((item) => parseInt(item));
          // console.log(this.checkList, '===============>配置', this.serverList);
        }
        console.log("queryUserConfig=======>", res);
      });
      // console.log('queryUserConfig=======>', 222222);
    },
    // 用户保存配置
    async saveUserConfig(body) {
      await manSaveUserConfig(body).then((res) => {
        console.log(res, "用户保存了==========>");
      });
    },
    getContentQuailty() {
      getContentQuailty(this);
    },
    // 查询分发范围
    getDistributionScope() {
      getDistributionScope(this);
    },
    // 内容性质、文章级别、内容分发数据统一梳理方法
    dataTraversal(list, name) {
      list.map((item) => {
        if (item.id == name) {
          let arr = {};
          arr.attributeCode = item.code;
          arr.attributeType = item.type;
          this.contentAttributes.push(arr);
        }
      });
    },
    // 搜索内容属性处理
    searchDataProcessing() {
      searchDataProcessing(this);
    },
    //查询当前运营所有的业务
    listContentBusinessForUserMan() {
      listContentBusinessForUserMan({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        res?.contentBusinesses?.forEach((item) => {
          // 改版注掉f
          // this.select[13].List.push({
          //   label: item.name,
          //   value: item.id
          // })
          this.businessList.push({
            label: item.name,
            value: item.id,
          });
          this.select.map((subItem) => {
            if (subItem.prop == "business" && subItem.cfgID == 4000) {
              subItem.List.push({
                label: item.name,
                value: item.id,
              });
            }
            return subItem;
          });
        });
      });
    },
    getGeneralLabel() {
      getGeneralLabel(this);
    },
    getDoctor(val) {
      if (val != "") {
        queryDoctorName({
          tenantId: this.$commonJs.getTenantId(),
          doctorName: val.trim(),
        })
          .then((res) => {
            // 如果有结果 代表是体制内的医生
            if (res.length > 0) {
              res &&
                this.select.map((item) => {
                  if (item.prop == "answerer") {
                    item.List = res.map((item) => ({
                      value: item.docId,
                      label: `${item.docName} ${item.hospitalName}`,
                    }));
                  }
                });
            } else {
              // 没有结果 代表是体制外的医生
              this.select.map((item) => {
                if (item.prop == "answerer") {
                  item.List = [];
                }
              });
              this.selectList.answerer = val;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.select.map((item) => {
          if (item.prop == "answerer") {
            item.List = [];
          }
        });
      }
    },
    // 上传弹窗关闭
    closeDialog() {
      let fileVal = this.$refs.file;
      fileVal.value = "";
      this.fileResult = "";
      this.fileName = "";
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    //导出弹窗关闭
    closeOutDialog() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // 下载模板或失败数据
    downloadDiles(type) {
      if (type == 1) {
        this.isButton = true;
        window.open(
          "//storage.jd.com/cms-bucket/ImportTemplateQA/%E5%AF%BC%E5%85%A5%E9%97%AE%E7%AD%94%E5%BA%93%E6%A8%A1%E6%9D%BF.xlsx?Expires=3773299828&AccessKey=Jd9HhkNEAtwojp2B&Signature=KEnlTo9y6FQWHnQE2YVV3q%2F1UHA%3D"
        );
        setTimeout(() => {
          this.isButton = false;
        }, 3000);
      }

      if (type == 2) {
        window.open(this.errUrl);
        this.isDownShow = false;
        let errType = JSON.parse(sessionStorage.getItem("errorDown"));
      }
      if (type == 3) {
        this.isButton = true;
        window.open(
          "//storage.360buyimg.com/cms-bucket/ImportTemplate/%E5%AF%BC%E5%85%A5%E5%86%85%E5%AE%B9%E5%85%B3%E8%81%94%E7%B1%BB%E7%9B%AE%E6%A8%A1%E6%9D%BF.xlsx?Expires=3810106704&AccessKey=Jd9HhkNEAtwojp2B&Signature=XtmgTIEu8TAo8ygsLoa1GfgZ%2Faw%3D"
        );
        setTimeout(() => {
          this.isButton = false;
        }, 3000);
      }
      if (type == 4) {
        window.open(this.failImportUrl);
        this.isImportErrorShow = false;
      }
      if (type == 5) {
        window.open(this.failExportUrl);
        this.isExportErrorShow = false;
      }
      if (type == 7) {
        window.open(this.failImportSaleUrl);
        this.isSaleImportErrorShow = false;
      }
      if (type == 8) {
        window.open(this.failExportSaleUrl);
        this.isSaleExportErrorShow = false;
      }
      if (type === 9) {
        this.isButton = true;
        window.open(
          "//storage.jd.com/cms-bucket/importExcel/8/ImportTemplate/contentSkuImportTemplate.xlsx?Expires=3833524616&AccessKey=Jd9HhkNEAtwojp2B&Signature=mODKdxJ13Gue7p%2FfWtXwMPeQ76M%3D"
        );
        setTimeout(() => {
          this.isButton = false;
        }, 3000);
      }
      if (type == 13 || type == 15) {
        this.isButton = true;
        getImportTemplate({
          importExportCode: type,
        }).then((res) => {
          if (res.templateUrl) {
            const excelUrl = res.templateUrl.replace(
              "http://storage.jd.local",
              "https://storage.360buyimg.com"
            );
            window.location.href = excelUrl;
            this.$message.success(`下载成功`);
          }
        });
        setTimeout(() => {
          this.isButton = false;
        }, 3000);
      }
    },
    // 上传文件校验
    async fileChange(e) {
      fileChange(e, this);
    },
    // 上传问答
    async uploadExl() {
      uploadCategoryExl(this, 6);
    },
    // 批量上传问题
    async uploadQuestionExl() {
      uploadCategoryExl(this, 13);
    },
    // 上传类目
    async uploadCategoryExl() {
      uploadCategoryExl(this, 2);
    },
    // 导出类目
    async getOutContentCategory() {
      getOutArticleCategory(this, 2);
    },
    // 导出商品
    async getOutContentContentSkus() {
      getOutArticleCategory(this, 8);
    },
    // 上传商品
    async uploadContentSkusExl() {
      uploadCategoryExl(this, 8);
    },
    // 批量上传问题
    async uploadBatchesOfflineExl() {
      uploadCategoryExl(this, this.bOImportExportCode);
    },

    // --------------------------------- 列表表格相关方法 start ----------------------------------------
    // 请求参数方法
    formData() {
      if (this.selectList.range != "" || this.selectList.quality != "") {
        this.searchDataProcessing();
      }
      let lbArr = [];
      if (this.selectList.articleLabel) {
        this.selectList.articleLabel.map((item) => {
          lbArr.push(item[item.length - 1]);
        });
      }
      let authorsArr = [];
      let authors = {}; // 回答人的参数
      // 判断选择的回答人 是体制内的医生 还是别的
      if (typeof this.selectList.answerer === "number") {
        // 此时选择的是体制内的医生  入参为 docId
        this.selectList.docId = this.selectList.answerer;
        this.selectList.authorNamePrecise = "";
        authors.authorId = this.selectList.docId;
        authors.authorType = 2; // 2-体制内医生
      } else if (this.selectList.answerer.trim() != "") {
        // 此时选择的是体制内的医生  入参为 authorNamePrecise
        this.selectList.authorNamePrecise = this.selectList.answerer;
        this.selectList.docId = "";
        authors.authorNamePrecise = this.selectList.authorNamePrecise;
        authors.authorType = 5; // 5-回答人
      }
      if (authors.authorType) {
        authorsArr.push(authors);
      }
      // if (this.selectList.writerPin.length > 0){
      //   let authorsPin = {
      //     "pins" : [this.selectList.writerPin],
      //     "authorType" : 4
      //   }
      //   authorsArr.push(authorsPin);
      // }

      if (this.selectList.nickname.length > 0) {
        let authorNamePrecise = {
          authorNamePrecise: [this.selectList.nickname],
          authorType: 4,
        };
        authorsArr.push(authorNamePrecise);
      }

      if (this.selectList.hospital.length > 0) {
        let hospitalNamePrecise = {
          hospitalNamePrecise: this.selectList.hospital,
          authorType: 2,
        };
        authorsArr.push(hospitalNamePrecise);
      }
      // 索引
      let contentIndexIds = [];
      if (this.selectList.contentIndexIds.length > 0) {
        contentIndexIds = this.selectList?.contentIndexIds?.map(
          (item) => item?.[item?.length - 1]
        );
      }
      let parameter = {
        tenantId: this.$commonJs.getTenantId(),
        contentType: this.contentType,
        auditStatus: this.questionTabList.find(
          (item) => item.name === this.tabActiveName
        ).val,
        contentId: Number(this.selectList.questionId) || null, // 问题id
        contentName: this.selectList.contentName || null, // 标题
        searchKeyword: this.selectList.searchKeyword || null, // 全文
        diseaseIds: this.selectList.symptomsDisease
          ? [this.selectList.symptomsDisease]
          : [], // 疾病id
        startSubmitTime:
          (this.selectList.questionTime && this.selectList.questionTime[0]) ||
          null, // 开始时间
        endSubmitTime:
          (this.selectList.questionTime && this.selectList.questionTime[1]) ||
          null, // 结束时间
        docId: this.selectList.reviewDoctorName || null, // 医生id
        sourceTypes: this.selectList.questionSource
          ? this.selectList.questionSource.filter((item) => item != "全部")
          : null, // 问答来源
        contentStatus:
          this.selectList.questionStatus &&
          this.selectList.questionStatus != "全部"
            ? [this.selectList.questionStatus]
            : [], // 问答状态（1：上线 2：下线）
        categoryRelationIds: this.selectList.categoryRelationId
          ? [this.selectList.categoryRelationId]
          : [], //类目
        pageNo: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        authors: authorsArr, // 回答人信息
        startAuditTime:
          (this.selectList.auditTime && this.selectList.auditTime[0]) || null,
        endAuditTime:
          (this.selectList.auditTime && this.selectList.auditTime[1]) || null,
        contentAttributes: this.contentAttributes || [], // 内容属性
        businessIds:
          typeof this.selectList.business == "number"
            ? [this.selectList.business]
            : this.selectList.business || [],
        categoryIds:
          typeof this.selectList.categoryId == "number"
            ? [this.selectList.categoryId]
            : this.selectList.categoryId || [],
        channelIds:
          typeof this.selectList.channelId == "number"
            ? [this.selectList.channelId]
            : this.selectList.channelId || [],
        labelIds: lbArr || [],
        auditUser: this.selectList.auditUser || null,
        contentDiseasesNotNull:
          this.selectList.contentDiseasesNotNull &&
          this.selectList.contentDiseasesNotNull != "全部"
            ? this.selectList.contentDiseasesNotNull
            : null,
        isDoctor:
          this.selectList.isDoctor && this.selectList.isDoctor != "全部"
            ? this.selectList.isDoctor
            : null,
        contentIndexIds,
        createUser: this.selectList.writerPin || null,
      };
      return parameter;
    },
    // 导出请求参数方法
    exFormData() {
      if (this.selectList.range != "" || this.selectList.quality != "") {
        this.searchDataProcessing();
      }
      let lbArr = [];
      if (this.selectList.articleLabel) {
        this.selectList.articleLabel.map((item) => {
          lbArr.push(item[item.length - 1]);
        });
      }
      let authorsArr = [];
      let authors = {}; // 回答人的参数
      // 判断选择的回答人 是体制内的医生 还是别的
      if (typeof this.selectList.answerer === "number") {
        // 此时选择的是体制内的医生  入参为 docId
        this.selectList.docId = this.selectList.answerer;
        this.selectList.authorNamePrecise = "";
        authors.authorId = this.selectList.docId;
        authors.authorType = 2; // 2-体制内医生
      } else if (this.selectList.answerer.trim() != "") {
        // 此时选择的是体制内的医生  入参为 authorNamePrecise
        this.selectList.authorNamePrecise = this.selectList.answerer;
        this.selectList.docId = "";
        authors.authorNamePrecise = this.selectList.authorNamePrecise;
        authors.authorType = 5; // 5-回答人
      }
      if (authors.authorType) {
        authorsArr.push(authors);
      }
      // if (this.selectList.writerPin.length > 0){
      //   let authorsPin = {
      //     "pins" : [this.selectList.writerPin],
      //     "authorType" : 4
      //   }
      //   authorsArr.push(authorsPin);
      // }

      if (this.selectList.nickname.length > 0) {
        let authorNamePrecise = {
          authorNamePrecise: [this.selectList.nickname],
          authorType: 4,
        };
        authorsArr.push(authorNamePrecise);
      }

      if (this.selectList.hospital.length > 0) {
        let hospitalNamePrecise = {
          hospitalNamePrecise: this.selectList.hospital,
          authorType: 2,
        };
        authorsArr.push(hospitalNamePrecise);
      }
      // 索引
      let contentIndexIds = [];
      if (this.selectList.contentIndexIds.length > 0) {
        contentIndexIds = this.selectList?.contentIndexIds?.map(
          (item) => item?.[item?.length - 1]
        );
      }
      let parameter = {
        tenantId: this.$commonJs.getTenantId(),
        contentType: this.contentType,
        auditStatus: this.questionTabList.find(
          (item) => item.name === this.tabActiveName
        ).val,
        contentId: Number(this.selectList.questionId) || null, // 问题id
        contentName: this.selectList.contentName || null, // 标题
        searchKeyword: this.selectList.searchKeyword || null, // 全文
        diseaseIds: this.selectList.symptomsDisease
          ? [this.selectList.symptomsDisease]
          : [], // 疾病id
        startSubmitTime:
          (this.selectList.questionTime && this.selectList.questionTime[0]) ||
          null, // 开始时间
        endSubmitTime:
          (this.selectList.questionTime && this.selectList.questionTime[1]) ||
          null, // 结束时间
        docId: this.selectList.reviewDoctorName || null, // 医生id
        sourceTypes: this.selectList.questionSource
          ? this.selectList.questionSource.filter((item) => item != "全部")
          : null, // 问答来源
        contentStatus:
          this.selectList.questionStatus &&
          this.selectList.questionStatus != "全部"
            ? [this.selectList.questionStatus]
            : [], // 问答状态（1：上线 2：下线）
        categoryRelationIds: this.selectList.categoryRelationId
          ? [this.selectList.categoryRelationId]
          : [], //类目
        pageNo: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        authors: authorsArr, // 回答人信息
        startAuditTime:
          (this.selectList.auditTime && this.selectList.auditTime[0]) || null,
        endAuditTime:
          (this.selectList.auditTime && this.selectList.auditTime[1]) || null,
        contentAttributes: this.contentAttributes || [], // 内容属性
        businessIds:
          typeof this.selectList.business == "number"
            ? [this.selectList.business]
            : this.selectList.business || [],
        categoryIds:
          typeof this.selectList.categoryId == "number"
            ? [this.selectList.categoryId]
            : this.selectList.categoryId || [],
        channelIds:
          typeof this.selectList.channelId == "number"
            ? [this.selectList.channelId]
            : this.selectList.channelId || [],
        labelIds: lbArr || [],
        auditUser: this.selectList.auditUser || null,
        contentDiseasesNotNull:
          this.selectList.contentDiseasesNotNull &&
          this.selectList.contentDiseasesNotNull != "全部"
            ? this.selectList.contentDiseasesNotNull
            : null,
        isDoctor:
          this.selectList.isDoctor && this.selectList.isDoctor != "全部"
            ? this.selectList.isDoctor
            : null,
        contentIndexIds,
        createUser: this.selectList.writerPin || null,
      };
      return parameter;
    },
    // 筛选项查询数据的方法
    getData() {
      this.pagination.currentPage = 1;
      // 如果是 筛选项的查询  则 查询全部 auditStatus
      if (this.tabChange != 1) {
        this.tabActiveName = "全部";
      }
      this.getPageData();
    },
    // 页面列表分页获取方法
    getPageData() {
      // 如果是 tab栏 切换 则根据 当前tab栏的  auditStatus 去查
      let params = this.formData();
      if (this.tabActiveName == "全部") {
        params.auditStatus = [];
      }
      queryQuestionList(params)
        .then((res) => {
          // 每次分页的时候都需要查询一次 tab栏后面的数量
          this.tabChange = 1;
          this.getTabNum();
          this.tabChange = 0;
          if (res) {
            this.tblData = res.data;
            this.pagination.total = res.totalCount;
            this.pagination.currentPage = res.pageNo;
            this.pagination.pageSize = res.pageSize;
          }
        })
        .catch((err) => {
          console.log("获取列表数据出错");
          console.log(err);
        });
    },
    // --------------------------------- 列表表格相关方法 end ----------------------------------------

    // --------------------------------- 搜索表单相关方法 start ----------------------------------------
    // FORM 表单下拉数据 查询疾病库名称
    getDiseases(val) {
      if (val != "") {
        queryDiseaseLibraryName({
          tenantId: this.$commonJs.getTenantId(),
          diseaseName: val,
        })
          .then((res) => {
            res &&
              this.select.map((item) => {
                if (item.prop == "symptomsDisease") {
                  item.List = res.data.map((item) => ({
                    value: item.diseaseId,
                    label: item.diseaseName,
                  }));
                }
              });
          })
          .catch((err) => {
            console.log("获取疾病库名称出错");
            console.log(err);
          });
      }
    },
    // FORM 表单下拉数据 清空
    empty() {
      Object.keys(this.selectList).map((item) => {
        this.selectList[item] = "";
      });
      this.select.map((item) => {
        if (
          ["symptomsDisease", "categoryId", "channelId"].indexOf(item.prop) > -1
        ) {
          item.List = [];
        }
      });
      this.contentAttributes = [];
      console.log("清空数据---->", this.select, this.selectList);
      this.getData();
    },
    // --------------------------------- 搜索表单相关方法 end ----------------------------------------

    // --------------------------------- tab页 start ----------------------------------------
    // 文章状态切换查询
    tabHandleClick(tab) {
      this.pagination.currentPage = 1;
      this.getPageData();
    },
    // 获取tab页的每种类型的数量
    getTabNum() {
      let params = this.formData();
      if (this.tabChange === 1) {
        params.auditStatus = [1, 2, 3, 4];
      }
      queryQuestionStateNum(params)
        .then((res) => {
          res &&
            this.questionTabList.map((item) => {
              item.count =
                item.name === "全部"
                  ? res.allCount
                  : item.name === "待审核"
                  ? res.unAuditCount
                  : item.name === "已通过"
                  ? res.passAuditCount
                  : item.name === "已驳回"
                  ? res.rejectCount
                  : item.name === "已下线"
                  ? res.offlineCount
                  : 0;
            });
        })
        .catch((err) => {
          console.log("获取问题状态数量出错");
          console.log(err);
        });
    },
    // --------------------------------- tab页 end ----------------------------------------

    // --------------------------------- 上传下载 start ----------------------------------------
    downloadTemplate() {
      window.location.href =
        "//storage.jd.com/cms-bucket/ImportTemplateQA/%E5%AF%BC%E5%85%A5%E9%97%AE%E7%AD%94%E5%BA%93%E6%A8%A1%E6%9D%BF.xlsx?Expires=3773299828&AccessKey=Jd9HhkNEAtwojp2B&Signature=KEnlTo9y6FQWHnQE2YVV3q%2F1UHA%3D";
    },
    beforeUpload(file) {
      const isExcel =
        [
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
        ].indexOf(file.type) > -1;
      const isFileSize = file.size / 1024 / 1024 < 5;
      if (!isExcel) {
        this.$message.error("上传EXCEL文件格式不正确！");
      }
      if (!isFileSize) {
        this.$message.error("上传EXCEL文件大小不能超过 5MB!");
      }
      return isExcel && isFileSize;
    },
    async upload(params) {
      const { file } = params;
      let fileBase64 = await new Promise((resolve, reject) => {
        let reader = new FileReader();
        let fileResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          fileResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(fileResult);
        };
      });
      fileBase64 = fileBase64.replace(/data.+?;base64,/, "");
      try {
        const res = await importQuestionAnswer({
          tenantId: this.$commonJs.getTenantId(),
          fileBase64,
        });
        if (res) {
          this.dialogImportVisible = false;
          this.$message.success(
            `共上传${res.successNumber + res.failNumber}条，成功${
              res.successNumber
            }条,失败${res.failNumber}条`
          );
          this.fileList = [];
          this.dialogTableVisible = false;
          this.getPageData();
          this.getTabNum();
          return res.failNumber === 0;
        }
      } catch (err) {
        console.log(err);
        this.fileList = [];
        this.$message.error(err.msg || "上传失败！");
        return false;
      }
    },
    // --------------------------------- 上传下载 end ----------------------------------------

    // --------------------------------- 表格操作栏事件 start ----------------------------------------
    // 下线取消或者确定按钮
    offlineClickHandler(type) {
      if (type == "one") {
        this.dialogOfflineVisible = false;
      } else if (type == "two") {
        if (this.offLineReasons.trim() === "") {
          this.$message.error("请输入下线理由");
          return false;
        }
        offlineApplication({
          tenantId: this.$commonJs.getTenantId(),
          contentId: this.operatingRow.contentId,
          remark: this.offLineReasons.trim(),
          contentStatus: 2, // 1-上线  2-下线
        })
          .then((res) => {
            if (res) {
              this.$message.success("下线成功");
              this.dialogOfflineVisible = false;
              this.getPageData();
            }
          })
          .catch((err) => {
            this.$message.success("下线失败");
            console.log(err);
          });
      }
    },
    operate(row) {
      this.$router.push({
        path: "/questionAnswer/questionEdit",
        query: {
          id: row.contentId,
        },
      });
    },
    redirectTo(row) {
      const urlAddress = "//beta-api.m.jd.com";
      const url = `https://laputa${
        this.baseUrl == urlAddress ? "-yf" : ""
      }.healthjd.com/content/article/qadetail?id=${row.contentId}`;
      window.open(url);
    },
    // --------------------------------- 表格操作栏事件 end ----------------------------------------
    importChangeFn(v) {
      console.log("importChangeFn", v);
      if (v == 1) {
        this.dialogInContentSkusVisible = true;
      } else if (v == 2) {
        this.dialogInCategoryVisible = true;
      } else if (v == 3) {
        this.dialogTableVisible = true;
      } else if (v == 4) {
        this.dialogInQuestionVisible = true;
      }
    },
    exportChangeFn(v) {
      console.log("exportChangeFn", v);
      if (v == 1) {
        this.dialogOutContentSkusVisibleSku = true;
      } else if (v == 2) {
        this.dialogOutCategoryVisible = true;
      } else if (v == 3) {
        this.downloadDiles(8);
      } else if (v == 4) {
        this.downloadDiles(7);
      } else if (v == 5) {
        this.downloadDiles(5);
      } else if (v == 6) {
        this.downloadDiles(4);
      } else if (v == 7) {
        this.downloadDiles(2);
      }
    },
    batchesOfflineFn(v) {
      switch (Number(v)) {
        case 1:
          this.dialogOutBatchesOfflineVisible = true;
          break;

        default:
          break;
      }
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  computed: {
    ...mapState(["imgHost", "userInfo"]),
  },
};
</script>
<style lang="scss" scoped>
.questionList {
  .tbl {
    position: relative;
    padding: 20px;
    background: #fff;
    .downLoad-error {
      margin-right: 120px;
    }
    .downLoad-tag {
      margin-right: 270px;
    }
    .el-tabs {
      padding: 0;
    }
    .import-btn {
      position: absolute;
      top: 20px;
      right: 20px;
      z-index: 11;
      .redTag {
        color: red;
      }
    }
    .operateBtn {
      position: relative;
      &:before {
        content: " ";
        position: absolute;
        top: 10px;
        left: -6px;
        height: 8px;
        width: 2px;
        background-color: #266cee;
      }
      &:first-child {
        &:before {
          display: none;
        }
      }
    }
  }
}
.offlineForm {
  position: relative;
  padding: 20px;
}
.red {
  position: absolute;
  top: 36px;
  left: 44px;
  display: inline-block;
  color: red;
}
.importBtn {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  margin-left: 5px;
}
.exportBtn {
  margin-left: 5px;
  span {
    margin-top: 5px;
    display: block;
    color: #abaaaa;
  }
}
</style>
